module.exports = __webpack_public_path__ + "img/IchHasseDiesenWald.593f8992.jpg";